import React, {useEffect, useRef} from "react"
import styled from "styled-components"

import {H2} from "@irati/ui/src/Typography/Heading"
import {FormattedMessage, injectIntl} from "@irati/utils/lang"
import Button from "@irati/ui/src/Button"
import qs from "qs"
import tracking from "@irati-tracking/recognition/recognition"

import {InjectIntlProps} from "@irati/utils/lang/injectIntl"
import Icon, {IconTypes} from "@irati/ui/src/Icon"
import {useTheme} from "@irati/ui/src/global/useTheme"
import Flex from "@irati/ui/src/Flex"
import {Label} from "@irati/ui/src/Typography"
import RewardPointsIcon from "@irati/ui/images/reward_point.svg"
import Spacing from "@irati/ui/src/Spacing"

const Image = styled.img`
  height: 120px;
  width: 120px;
`
interface Props extends InjectIntlProps {
  onClickButton: () => void
  onHide: () => void
  timeoutMilliseconds?: number
  newRecognition?: boolean
}
const RecognitionSuccess: React.FC<Props> = (props) => {
  const theme = useTheme()
  const {formatMessage, onClickButton, onHide, timeoutMilliseconds = 30000, newRecognition} = props
  const closeSuccessTimeout = useRef(-1)
  useEffect(() => {
    const query = qs.parse(window.location.search.replace("?", ""))
    const rewardType = query.type === "add_reward" ? "add_reward" : "nomination"
    tracking.recognitionConfirmation({type: newRecognition ? "recognition" : rewardType})
    closeSuccessTimeout.current = setTimeout(onHide, timeoutMilliseconds)
    return () => {
      clearTimeout(closeSuccessTimeout.current)
    }
  }, [])
  const ctaText = newRecognition
    ? "recognition.popup.createRecognition.success.rewardAgainButton"
    : "recognition.popup.rewardRecognition.success.createAgainButton"
  return (
    <Flex direction="column" alignItems="center" justifyContent="center">
      <Spacing marginTop={theme.spacing.eight} marginBottom={theme.spacing.eight}>
        <Image alt={formatMessage({id: "recognition.popup.createRecognition.success.image"})} src={RewardPointsIcon} />
      </Spacing>
      <H2 marginBottom={theme.spacing.three}>
        <FormattedMessage id="recognition.successManager.lbl.rewardAdded" />
      </H2>
      <Button primary large full onClick={onClickButton} marginBottom={theme.spacing.two}>
        <FormattedMessage id={ctaText} />
      </Button>
      <Flex alignItems="center" justifyContent="center" gap={theme.spacing.one}>
        <Icon icon={IconTypes.info} color={theme.colors.greys.medium} />
        <Label small color={theme.colors.greys.medium}>
          <FormattedMessage id="recognition.successManager.lbl.hintRewardCreated" />
        </Label>
      </Flex>
    </Flex>
  )
}

export default injectIntl(RecognitionSuccess)
